export default __webpack_public_path__ + "static/media/Levitate D3.3 Converting impacts of CAVs to monetary terms.ac6b7f82.pdf";